import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { useInvalidateLockbox } from '@/modules/employer/components/Lockbox/LockboxDetails/hooks';

export interface MultipleRecordPayload {
  pages: number[];
  main: boolean;
}

interface Payload {
  multiple_records: MultipleRecordPayload[];
}

interface Props {
  lockboxId?: string;
}

const useLockboxSplittingQuery = ({ lockboxId }: Props) => {
  const queryClient = useQueryClient();
  const invalidateLockbox = useInvalidateLockbox(lockboxId);

  const { mutateAsync, isLoading, isError } = useMutation(
    (multipleRecords: Payload) =>
      api.post(API_URL.LOCKBOXES_SPLITTING_BY_LOCKBOX_ID(lockboxId || ''), multipleRecords),
    {
      onSuccess: () => {
        invalidateLockbox();
        queryClient.invalidateQueries({
          queryKey: [API_URL.ACTIVITY_LOGS],
        });
      },
    }
  );

  return {
    splitLockbox: mutateAsync,
    isLoading,
    isError,
  };
};

export default useLockboxSplittingQuery;
